import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA4, trackPageView } from '@/seo/gtag';

/**
 * Initializes GA4 once and sends a page_view on every SPA route change.
 */
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initGA4();
  }, []);

  useEffect(() => {
    // Let the route's SEOHead update document.title first.
    const id = window.setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 60);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
